import angular from 'angular';
import _ from 'lodash';

export default angular.module('privilege-templates-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      privilegeTemplates: {
        ACCOUNT_WITH_ROLE_EXISTS: () => ({
          title: gettextCatalog.getString('Cannot delete role. There are accounts referencing this role.'),
        }),
        ACCOUNT_HAS_TEMPLATE: () => ({ body: gettextCatalog.getString('Cannot delete role. There are accounts referencing this role.') }),
        ROLE_HAS_TEMPLATE: () => ({ body: gettextCatalog.getString('Cannot delete role.') }),
        ROLE_IS_DEFAULT: () => ({ body: gettextCatalog.getString('Cannot delete default role.') }),
        TEMPLATE_NAME_NOT_UNIQUE: () => ({ body: gettextCatalog.getString('Role Name must be unique.') }),
      },
      roleTemplates: {
        ACCOUNT_WITH_ROLE_EXISTS: () => ({
          title: gettextCatalog.getString('Cannot delete role. There are accounts referencing this role.'),
        }),
        ACCOUNT_HAS_TEMPLATE: () => ({ body: gettextCatalog.getString('Cannot delete role. There are accounts referencing this role.') }),
        ROLE_NAME_NOT_UNIQUE: () => ({ body: gettextCatalog.getString('Role Names must be unique.') }),
        ROLE_ALREADY_EXISTS: () => ({ body: gettextCatalog.getString('Role Name must be unique.') }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/config/errorcodes.conf.js